import { SAVED_RENDER_HISTORY_LIMIT } from '../utils/photorealistic/renderHistoryDisplay';
import RenderHistoryGrid from './RenderHistoryGrid';

function CompareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <line x1="12" y1="4" x2="12" y2="20" />
      <polyline points="10 9 8 12 10 15" />
      <polyline points="14 9 16 12 14 15" />
    </svg>
  );
}

const SavedRenderHistoryStrip = ({
  visible = false,
  items = [],
  loading = false,
  renderingJobs = [],
  error = null,
  onSelectItem,
  onSaveItem,
  onDeleteItem,
  onCompare,
  compareActive = false,
  compareSelectedIds = [],
  onCompareToggleItem,
  savingItemId = null,
  serverRenderHistory = [],
  saveLimitReached = false,
  deletingItemId = null,
}) => {
  if (!visible) return null;

  const showGrid = items.length > 0 || renderingJobs.length > 0;
  const compareableCount = items.filter((item) => item?.imageUrl || item?.lightboxImageUrl).length;
  const compareDisabled = compareableCount < 2 || renderingJobs.length > 0;
  const compareTooltip = compareDisabled
    ? renderingJobs.length > 0
      ? 'Wait for renders to finish before comparing'
      : 'Add at least 2 renders to compare'
    : compareActive
      ? 'Exit compare'
      : 'Compare renders';

  return (
    <section
      className="mx-auto mb-3 w-full max-w-[min(100%,1024px)] shrink-0 border-t border-gray-200/80 bg-white/50 px-3 py-3 backdrop-blur-sm"
      aria-label="Recent saved renders"
    >
      <div className="mb-2 flex items-center justify-between gap-2">
        <h4 className="text-xs font-semibold uppercase tracking-wide text-gray-600">
          Recent renders
        </h4>
        {onCompare ? (
          <button
            type="button"
            onClick={onCompare}
            disabled={compareDisabled}
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              compareActive
                ? 'border-primary-300 bg-primary-300 text-white hover:bg-primary-400'
                : 'border-gray-200 bg-white/95 text-gray-600 hover:border-primary-300 hover:text-primary-300'
            }`}
            title={compareTooltip}
            aria-label={compareTooltip}
          >
            <CompareIcon />
          </button>
        ) : null}
      </div>

      {compareActive ? (
        <p className="mb-2 mt-[-25px] text-center text-[11px] text-gray-500">
          Select 2 renders to compare ({compareSelectedIds.length}/2)
        </p>
      ) : null}

      {loading && renderingJobs.length === 0 ? (
        <p className="text-center text-xs text-gray-500 py-1">Loading saved renders…</p>
      ) : error ? (
        <p className="text-center text-xs text-red-600 py-1">{error}</p>
      ) : !showGrid ? (
        <p className="text-center text-xs text-gray-500 py-1">No renders yet. Click Render to generate one.</p>
      ) : (
        <RenderHistoryGrid
          items={items}
          columns={SAVED_RENDER_HISTORY_LIMIT}
          maxVisibleItems={SAVED_RENDER_HISTORY_LIMIT}
          renderingJobs={renderingJobs}
          compareActive={compareActive}
          compareSelectedIds={compareSelectedIds}
          onCompareToggleItem={onCompareToggleItem}
          onSelectItem={onSelectItem}
          onSaveItem={compareActive ? undefined : onSaveItem}
          onDeleteItem={compareActive ? undefined : onDeleteItem}
          savingItemId={savingItemId}
          serverRenderHistory={serverRenderHistory}
          saveLimitReached={saveLimitReached}
          deletingItemId={deletingItemId}
          className="mx-auto max-w-full"
        />
      )}
    </section>
  );
};

export default SavedRenderHistoryStrip;
